<template>
	<div class="col-12">
		<div class="panel_header">
			<div class="row align-items-end">
				<div v-if="block.block_title" class="col-12">
					<h2>{{ block.block_title }}</h2>
				</div>
				<div v-if="block.subtitle" class="col-12">
					<p>{{ block.subtitle }}</p>
				</div>
			</div>
		</div>

		<div v-if="okSuccessMessage">
			<div>
				<div>
					<h4 class="title title-lg mb-4">
						{{ okSuccessMessage.title }}
					</h4>
					<div v-html="okSuccessMessage.value" />
				</div>
				<div
					v-if="okSuccessMessage.is_button_enabled == 1"
					class="p-4 w-lg-50"
				>
					<a :href="okSuccessMessage.button_link">
						<b-button variant="primary">
							{{ okSuccessMessage.button_text }}
						</b-button>
					</a>
				</div>
			</div>

			<FormulateInput
				type="button"
				@click="onClickAgainSubmit"
			>
				Отправить форму повторно
			</FormulateInput>
		</div>
		<div v-else>
			<div
				v-if="mounted && autocompleted"
			>
				<FormulateForm
					v-slot="{ isLoading, hasErrors }"
					ref="formulate_probono"
					v-model="formValues"
					remove-label
					@setCompanyInfo="setCompanyInfo"
				>
					<slot name="header">
						<div class="form-row mb-4">
							<div class="col-12 title">
								Основная информация
							</div>
						</div>
					</slot>
					<div class="form-row mb-4">
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								type="text"
								name="first_name"
								label="Имя *"
								placeholder="Введите значение"
								class=""
								validation-name="Имя"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								type="text"
								name="middle_name"
								label="Отчество *"
								validation="required"
								placeholder="Введите значение"
								class=""
								validation-name="Отчество"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								type="text"
								name="last_name"
								label="Фамилия *"
								placeholder="Введите значение"
								class=""
								validation="required"
								validation-name="Фото профиля"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								type="date"
								name="birthday"
								label="Дата рождения *"
								placeholder="Выберите значение"
								class=""
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								type="text"
								name="email"
								label="Email *"
								class=""
								placeholder="Введите значение"
								validation="bail|required|email"
								validation-name="email"
								:validation-messages="{
									'email': 'введите корректный e-mail',
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								id="phone"
								type="text"
								name="phone"
								label="Телефон *"
								class=""
								placeholder="Введите значение"
								validation="bail|required|matches:/[0-9()-+ ]+$/"
								validation-name="Телефон"
								:validation-messages="{
									'required': 'обязательно к заполнению',
									'matches': 'введите корректный номер телефона',
								}"
							/>
						</div>
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								id="residence_city"
								type="text"
								name="residence_city"
								label="Город проживания *"
								class=""
								placeholder="Введите значение"
								validation="required"
								validation-name="Город проживания"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								id="studied_skolkovo"
								type="text"
								name="studied_skolkovo"
								label="Учились ли Вы ранее на программах Школы управления СКОЛКОВО? *"
								class=""
								placeholder="Введите значение"
								validation="required"
								validation-name="Учились ли Вы ранее на программах Школы управления СКОЛКОВО?"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
					</div>
					<div class="form-row">
						<div class="col-12 title mb-4">
							Информация о фонде, в котором работает заявитель
						</div>
					</div>
					<div class="form-row mb-4">
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								id="company_name"
								type="text"
								name="company_name"
								label="Название фонда *"
								class=""
								placeholder="Введите значение"
								validation="required"
								validation-name="Название фонда"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								type="text"
								name="inn"
								label="ИНН *"
								placeholder="Введите значение"
								class=""
								validation-name="ИНН"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>

						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								type="text"
								name="job_title"
								label="Должность *"
								placeholder="Введите значение"
								class=""
								validation-name="Должность"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>

						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								type="text"
								name="company_industry"
								placeholder="Введите значение"
								label="Основное направление деятельности *"
								class=""
								validation-name="Основное направление деятельности"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								type="text"
								name="geography_presence"
								label="География присутствия *"
								placeholder="Введите значение"
								class=""
								validation-name="География присутствия"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								type="text"
								name="company_site_URL"
								label="Ссылка на сайт *"
								placeholder="Введите значение"
								class=""
								validation-name="Ссылка на сайт"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
						<!-- <div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								type="date"
								name="date_company_foundation"
								label="Дата основания (Фонд должен быть зарегистрирован не позднее чем за 2 года до подачи заявки на участие в конкурсе) *"
								placeholder="Введите значение"
								class=""
								validation-name="Дата основания"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div> -->
						<div class="relative col-12 col-md-12 col-lg-6 mb-3 custom-padding">
							<FormulateInput
								type="date"
								name="start_date_work_fund"
								label="Дата начала работы в фонде *"
								placeholder="Введите значение"
								class=""
								validation-name="Дата начала работы в фонде"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
					</div>
					<div class="form-row">
						<div class="col-12 title mb-4">
							Программа участия
						</div>
					</div>
					<div class="form-row mb-4">
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								type="select"
								name="program_wants_participate"
								label=""
								class=""
								:options="options"
								validation-name="Выберите программу"
								placeholder="Выберите значение"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
					</div>
					<div class="form-row">
						<div class="col-12 title mb-4">
							Мотивационное письмо
						</div>
						<ul class="mb-4">
							<li>
								Почему вы хотите учиться в Школе управления Сколково?
							</li>
							<li>
								Какой личный или профессиональный опыт вы хотели бы получить?
							</li>
							<li>
								Почему вы связали свою профессиональную карьеру в некоммерческом секторе?
							</li>
							<li>
								Какую цель или задачу Фонда вы планируете решить через обучение на программе?
							</li>
						</ul>
					</div>
					<div class="form-row mb-4">
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								name="nko_motivation_letter"
								label="Загрузите файл в формате .doc, .docx или .pdf (не меньше одного листа А4) *"
								class=""
								validation-name="Мотивационное письмо"
								type="file"
								validation="bail|size:50|^required|mime:application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
								:validation-messages="{
									'mime': 'Требуется формат документа .doc, .docx или .pdf',
									'required': 'обязательно к заполнению',
								}"
								upload-behavior="delayed"
							/>
						</div>
					</div>
					<div class="form-row">
						<div class="col-12 title mb-4">
							Письмо-рекомендация от руководства Фонда
						</div>
					</div>
					<div class="form-row mb-4">
						<div class="relative col-12 col-md-12 col-lg-6 mb-3">
							<FormulateInput
								name="letter_recommendation"
								label="Загрузите файл в формате .doc, .docx или .pdf *"
								class=""
								validation-name="Письмо-рекомендация от руководства Фонда"
								type="file"
								validation="bail|size:50|^required|mime:application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
								:validation-messages="{
									'mime': 'Требуется формат документа .doc, .docx или .pdf',
									'required': 'обязательно к заполнению',
								}"
								upload-behavior="delayed"
							/>
						</div>
					</div>

					<div class="form-row mb-4">
						<div class="col-12 order-10">
							<agreement-input />
							<advertising-mailings-input />
						</div>
					</div>

					<div class="d-flex align-items-center mt-2">
						<FormulateInput
							type="submit"
							class="mb-0"
							:disabled="isLoadingSubmit"
							@click="submit"
						>
							<b-spinner
								v-if="isLoadingSubmit"
								style="margin-right: 15px; width: 1.3em; height: 1.3em;"
							/>
							{{ isLoadingSubmit ? 'Отправляется...' : 'Отправить' }}
						</FormulateInput>
						<span v-if="isError" class="m-2 text-danger">
							Заполните поля
						</span>
						<CookieError v-if="isErrorCookie" />
					</div>
				</FormulateForm>
			</div>
		</div>
	</div>
</template>

<script>
import formulateFormScenario from '~/mixins/formulateFormScenario';
import AgreementInput from '~/components/panels/formulate/products/components/AgreementInput.vue';
import AdvertisingMailingsInput from '~/components/panels/formulate/products/components/AdvertisingMailingsInput.vue';
import formulateUserProfile from '~/mixins/formulateUserProfile';
import { mapActions } from 'vuex';
import CookieError from '~/components/panels/formulate/products/components/CookieError.vue';
import moment from '@/utils/moment';

export default {
	components: {
		AgreementInput,
		AdvertisingMailingsInput,
		CookieError,
	},
	mixins: [formulateFormScenario, formulateUserProfile],
	data() {
		return {
			status: 'default',
			phoneMask: null,
			industries: [],
			fullCityInfo: null,
			values: {
				first_name: '',
				last_name: null,
				last_family_name: '',
				middle_name: '',
				birthday: '',
				email: '',
				phone: '',
				residence_city: '',
				company_name: '',
				inn: '',
				job_title: '',
				company_industry: '',
				geography_presence: '',
				company_site_URL: '',
				// date_company_foundation: '',
				start_date_work_fund: '',
				program_wants_participate: '',
				nko_motivation_letter: '',
				letter_recommendation: '',
				studied_skolkovo: '',
			},
			options: {
				'Онлайн-кампус СКОЛКОВО': 'Онлайн-кампус СКОЛКОВО',
				'Digital Shift': 'Digital Shift',
				FLOW: 'FLOW',
				'Развитие лидерского потенциала': 'Развитие лидерского потенциала',
				'Стратегическое лидерство': 'Стратегическое лидерство',
				'Лидеры как преподаватели': 'Лидеры как преподаватели',
				'Управление проектами': 'Управление проектами',
				'Управление проектами изменений': 'Управление проектами изменений',
				'Операционная эффективность': 'Операционная эффективность',
				'Healthcare Management': 'Healthcare Management',
				'СКОЛКОВО Практикум': 'СКОЛКОВО Практикум',
				'Стартап Академия': 'Стартап Академия',
				'Практикум по финансовой стратегии': 'Практикум по финансовой стратегии',
				'Личный бренд: стратегия вашего продвижения': 'Личный бренд: стратегия вашего продвижения',
				'Сила наших связей: как формировать свое окружение': 'Сила наших связей: как формировать свое окружение',
				'OKR: как сфокусировать команду на общий результат': 'OKR: как сфокусировать команду на общий результат',
				'Executive-коучинг и менторство': 'Executive-коучинг и менторство',
				'Master in Public Strategy': 'Master in Public Strategy',
				'Публичная коммуникация сложных управленческих решений': 'Публичная коммуникация сложных управленческих решений',
				'Культурный код': 'Культурный код',
				LIFT: 'Leadership Identity Foundation and Transformation',
				Тандемократия: 'Тандемократия',
				'Бренд-стратегия: комплексный подход к управлению брендом компании': 'Бренд-стратегия: комплексный подход к управлению брендом компании',
				'Agile и гибридные методы управления проектами': 'Agile и гибридные методы управления проектами',
				'Управление проектами: как правильно делать правильные вещи': 'Управление проектами: как правильно делать правильные вещи',
				'Сотрудник как клиент: драйверы, инструменты и метрики эффективности': 'Сотрудник как клиент: драйверы, инструменты и метрики эффективности',
				'Эффективные переговоры в сложной деловой среде': 'Эффективные переговоры в сложной деловой среде',
				'Лидерство и влияние в организации': 'Лидерство и влияние в организации',
				'Лидерство в действии (выездная программа)': 'Лидерство в действии (выездная программа)',
			},
			additionalData: {
				id: '',
				inn: '',
				industry_id: '',
			},
			isError: false,
		};
	},
	computed: {
		isValidForm() {
			return this.$refs.formulate_probono.isValid;
		},
	},
	watch: {
		fullCityInfo(val) {
			if (val) {
				this.formValues.residence_city = val.data.city;
			}
		},
		'formValues.industry': {
			handler(val) {
				this.additionalData.industry_id = val;
			},
		},
	},
	created() {
		this.autocomplete();
		this.loadRoles();
	},
	methods: {
		getData() {
			let userData = this.formValues;

			if (!this.agreements.marketing_emails) {
				this.agreements.marketing_emails = !!this.formValues.advertisingMailingsAgreement;
			}
			if (!this.agreements.personal_data) {
				this.agreements.personal_data = !!this.formValues.personalData;
			}
			this.setAgreementFields();

			userData = {
				sklTargetAction: this.block.form_scenario_action_label,
				sklAgreeSubscribeLookup: this.formValues.advertisingMailingsAgreement ? 'да' : 'нет',
				sklBirthDate: this.formValues.birthday ? moment(this.formValues.birthday).format('DD.MM.YYYY') : '',
				...userData,
				...this.getAnalyticsData(),
			};

			return {
				user_data: userData,
				entity_name: this.fetchedData.entity_name,
				entity_id: this.fetchedData.id,
			};
		},
		...mapActions({
			loadRoles: 'profile/getRoles',
		}),
		async autocomplete() {
			try {
				const qs = `${Object.keys(this.values)
					.map((key) => `slugs[]=${encodeURIComponent(key)}`)
					.join('&')}`;

				const { data: values, visibility } = await this.$api.getUserProfileFields(qs);
				this.visibility = visibility;
				Object.keys(values).forEach((key) => {
					if (values[key]) {
						if (key === 'letter_recommendation') {
							this.formValues.letter_recommendation = [{
								url: values[key],
								name: 'Письмо_с_рекомендацией',
							}];
						} else if (key === 'nko_motivation_letter') {
							this.formValues.nko_motivation_letter = [{
								url: values[key],
								name: 'Письмо_мотивация',
							}];
						} else {
							this.formValues[key] = values[key];
						}
					}
				});

				const { data: industries } = await this.$api.expertBlocks();
				this.industries = industries;
			} catch (error) {
				console.log(error);
			}
		},
		async submit() {
			this.isError = false;
			if (this.isValidForm) {
				this.isLoadingSubmit = true;
				this.errorMessage = null;

				if (!this.isCookiesAccepted) {
					this.showCookieError();
					this.isErrorCookie = true;
					this.isLoadingSubmit = false;

					return;
				}
				const data = this.getData();

				this.isErrorCookie = false;

				window.dataLayer = window.dataLayer || [];
				// eslint-disable-next-line no-undef
				dataLayer.push({
					event: 'form_send',
					form_data: data,
				});

				const formData = new FormData();

				this.createFormData(formData, data);

				await this.$api
					.submitFormulateForm(
						this.block.scenario_id,
						formData,
					)
					.then((response) => {
						window.location = response.url;
					})
					.catch((error) => {
						this.isLoadingSubmit = false;
						if (error.response.status === 422) {
							this.errorMessage = 'Вы уже подали заявку ранее. В ближайшее время с Вами свяжется консультант';
						}
					});
			} else {
				this.isError = true;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.text-decoration-none {
	cursor: pointer;
}

.formulate-form, .custom-control-label, .formulate-input, .formulate-input .formulate-input-label {
	font-family: $font-family-base !important;
	font-weight: 500 !important;
}

.field-required {
	&.formulate-input[data-classification='text'] input {
		border: 1px solid red !important;
	}
}

.custom-switch {
	line-height: 1.8;
}

.alert-primary {
	color: $white;
	background-color: $link-color;
	border-color: $link-color;
}

.close_link {
	display: flex;
	align-items: center;
	justify-content: space-between;
	line-height: 1;
	padding: 0;
	border: 0;
	background: transparent;
	outline: 0;
	cursor: pointer;

	&::after {
		position: relative;
		content: "\e915";
		font-family: "sk_icons";
		line-height: 1;
		font-size: .8rem;
		margin-left: 0.5rem;
		padding: 4px;
		cursor: pointer;
	}
}

span {
	margin: 0;
	line-height: 1.3;

	&.price-muted {
		font-size: 1.5rem;
		text-decoration: line-through;
		color: $border-color;
	}
}

.end-price {
	background: #FFFFFF;

	.amount-wrapper {
		border-right: 1px dashed $border-color;
		height: 100%;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		padding-right: 30px;
	}
}

.amount {
	font-weight: bold;
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	flex-direction: column;
	@include media-breakpoint-up(sm) {
		justify-content: space-between;
		flex-direction: row;
		align-items: center;
	}
}

.total-price {
	padding: 1rem;
	border: 1px solid $border-color;
	display: flex;
	background-color: #455FED;
	color: #FFFFFF;
	flex-direction: column;
	justify-content: space-between;
	@include media-breakpoint-up(sm) {
		padding: 2rem 1.5rem;
	}

	.description-small {
		font-weight: 400;
		line-height: 20px;
		color: #9BA9F7;

	}

	.education {
		border-top: 1px solid #FFFFFF;
	}

	input {
		background-color: transparent;
		border: none;
		border-bottom: 1px solid $border-color;
		width: 100%;
		outline-style: none;

		&::placeholder {
			color: $border-color;
		}
	}

	.input_under_span {
		font-size: 0.8rem;
		line-height: 1.2;
		font-weight: normal;
	}

	.btn-outline-secondary {
		color: $border-color;
		border-color: $border-color;

		&:hover {
			color: $white;
			border-color: $link-hover-color;
			background-color: $link-hover-color;
		}
	}

	.sum {
		margin: 2rem 0;
	}
}

// .custom-control-input:checked ~ .custom-control-label::before {
// 	color: #fff;
// 	border: #FFFFFF;
// }

.discount {
	.formulate-input-element {
		&.formulate-input-element--text {
			input {
				border: none !important;
				border-bottom: 1px solid black !important;
				padding-left: 0px !important;
				padding-bottom: 1rem !important;

				&::placeholder {
					color: black !important;
				}
			}
		}

		&.formulate-input-element--submit {
			button {
				font-weight: 400 !important;
			}
		}

	}
}

.relative {
	position: relative;
}

.user-profile-dadata-input-label {
	font-weight: 500;
	line-height: 1.2;
	margin-bottom: 0.5rem;
}

.custom-padding {
	padding-top: 0rem !important;

	@include media-breakpoint-up(lg) {
		padding-top: 1.2rem !important;
	}
}

</style>
<style lang="scss">
.user-profile-dadata-input {
	& .vs__input {
		border-radius: 0 !important;
		border: 1px solid #949ABA !important;
		font-size: 1rem !important;
		padding: 1.3rem 1rem 1.3rem 1rem !important;
		line-height: 1.5rem !important;
		height: calc(1.5em + 0.75rem + 2px);
		font-family: "Raleway", sans-serif;
		font-weight: 500;

		&::placeholder {
			font-weight: 300;
			color: #959BBA;
		}
	}
}

.user-profile-industries-select {
	border-radius: 0 !important;
	border: 1px solid #949ABA !important;
	font-size: 1rem !important;
	padding-left: 1rem;
	line-height: 1.5rem !important;
	height: 2.7rem;
	font-family: "Raleway", sans-serif;
	font-weight: 500;
	background-position-x: 96%;

	&::placeholder {
		font-weight: 300;
		color: #959BBA;
	}
}
</style>
